import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Modal, { ModalContent, ModalFooter } from 'Components/Modal';

const ExitModal = ({ onExitClassroom, onCloseExitModal, openExitModal, ...props }) => {
  const { t } = useTranslation('classroom');

  return (
    <Modal
      contents={
        <ModalContent
          imageUrl={'/assets/images/classroom/exitModal.svg'}
          title={<Trans defaults={`${t('EXIT_CLASSROOM_MODAL.TITLE')}`} />}
          description={`${t('EXIT_CLASSROOM_MODAL.DESCRIPTION')}`}
        />
      }
      footer={
        <ModalFooter
          justifyContent={'center'}
          primaryButtonLabel={`${t('EXIT_CLASSROOM_MODAL.EXIT_BUTTON')}`}
          onPrimaryButtonClick={onExitClassroom}
          secondaryButtonLabel={`${t('EXIT_CLASSROOM_MODAL.CONTINUE_BUTTON')}`}
          onSecondaryButtonClick={onCloseExitModal}
          flexDirection={{ _: 'column-reverse', sm: 'row' }}
        />
      }
      footerProps={{ mt: 7 }}
      muiProps={{ isActive: openExitModal }}
      {...props}
    />
  );
};

export default ExitModal;
